
import {HTTP} from './repository'
import {store} from './store/store'
export default{
    methods:{
        AddTokenToAPI(token){
            
            HTTP.defaults.headers.post['token']=token
        },
        AddUserToAPI(user){
            //console.log('add user to api ' + user.userId + ' ' + user.userKey)
            HTTP.defaults.headers.post['adminuser']=user.user_personId + '|' + user.userKey
        },
        AddIPToAPI(myip){
            HTTP.defaults.headers.post['ipaddress']=myip
        },
        getFailureResponse(message){
            
            if(message.includes('401')){
                message=''//'You are not authorized. Please check your login credentials.'
                store.dispatch('failedAuthLogout');
            }
            return {
                'Successful':false,
                'Message':message
            }
        },
        async callAPI(req,method){
            try{
                var response = await HTTP.post(method,req)
                if(response.data.Successful==false){return this.getFailureResponse(response.data.RequestException.Message)}
                return response.data
            }
            catch(e){
                console.log(e)
                return this.getFailureResponse(e.message)
            }
        }, 
    },
    
}